export function validateCohortName(cohortName, cohorts) {
    if (!cohortName) {
        return 'Enter cohort name';
    }

    if (!cohortName.replace(/\s/g, '').length) {
        return 'Cohort name cannot contain only space characters';
    }

    if (cohorts.filter(cohort => cohort.name === cohortName).length) {
        return 'Cohort with this name already exists';
    }
    return null;
}